import React, { Component } from 'react'
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import AttachFile from '@material-ui/icons/AttachFile';
import Edit from '@material-ui/icons/Edit';
import Divider from '@material-ui/core/Divider';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import SearchableDropDown from '../SharedComponents/SearchableDropDown';

import config from "../../config/config";
import axios from 'axios';

import {text_truncate} from "../../util/StringUtil"

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

class TaskDialog extends Component {
    state = {
        open: this.props.open,
        scroll: 'paper',
        requiredFields: [{
            id: 0,
            required: false,
            attachment: false,
            type: "Text",
            textType: "free text",
            attachment_list: []
        }],
        index: 0,
        task: {
            task_Assignee: "",
            description: "",
            due_date: new Date(),
            questions: [{
                id: 0,
                question_type: "Text",
                question_text: "",
                response:"No Response",

            }],
            file: []
        },
        tempID: 0,
        selectedOption:null

    };

    componentDidUpdate(prevProps){
        // console.log(prevProps.open + "   " + this.props.open)
        if (prevProps.open !== this.props.open)
        this.setState({open:this.props.open});
    }

    //handle close dialog
    handleClose = () => {
        this.setState({ open: false });
        this.props.close();
    };
    //handle submit dialog
    handleSubmit = () =>{
        let postObj = this.createSubmitObj();
        let isRequiredFieldFilled = true;
        for (var key in postObj){
            console.log(postObj[key]);
            if(postObj[key] == ""){
                console.log(key+" is null value")
                isRequiredFieldFilled = false;
            }
        }

        if (isRequiredFieldFilled){
            console.log("submit data");
            console.log(postObj);
            axios.post(config.tasks(this.props.id),postObj)
                .then(res=>{
                    console.log(res);
                    this.props.submitUpdate(this.props.id);})
                .catch(error=>{console.log(error.response)});

            this.setState({ open: false });

            this.props.close();
        }else{
            alert("Please fill all the required field");
        }
    };

    createSubmitObj(){
        let postObj = {
            assigned_user: this.state.task.task_Assignee,
            description: this.state.task.description,
            due_date: this.state.task.due_date,
            questions: this.state.task.questions,
            alert: 1,
            created_user: 1
        };
        return postObj;
    }

    handleRadioGroupChange = (e, id) => {
        let updateField = this.state.requiredFields.find(o=>o.id == id);
        let updateqFieldIndex = this.state.requiredFields.indexOf(updateField);
        updateField.textType = e.target.value;
        this.setState(state => {this.state.requiredFields[updateqFieldIndex] = updateField});

        let updateObj = this.state.task.questions.find(o=>o.id == id);
        let updatequestionIndex = this.state.task.questions.indexOf(updateObj);
        updateObj.value = e.target.value;
        this.setState(state => {this.state.task.questions[updatequestionIndex] = updateObj});

        this.forceUpdate();
    };

    handleTextfieldChange = (e) =>{
        let name = e.target.name;
        let value = e.target.value;
        // console.log("in text field change")
        // console.log(name)
        // console.log(value)
        this.setState(state =>{this.state.task[name] = value;});
    };

    handleDueDateChange = (date) => {
        // console.log('handleDueDateChange : ' + date)
        this.setState(state =>{this.state.task.due_date = date;})
        this.forceUpdate()
    }

    handleChange = name => selectedOption => {
        this.setState({ selectedOption });
        // console.log(`Option selected:`, selectedOption);
        if (selectedOption)
        {        
            // let name = selectedOption.label;
            let value = selectedOption.value;
            // console.log(name)
            // console.log(value)
            this.setState(state =>{this.state.task[name] = value;});
        }
    }

    handleFileUpload = (e) => {
        let value = e.target.value;
        this.setState(state =>{this.state.task["file"].push(value);});
    };

    handleQuestionAdd = (id) => {
        let obj = {
            id: id,
            question_type: "",
            question_text: "",
            value: ""
        };
        this.setState(state => {this.state.task.questions.push(obj);});
    };

    handleQuestionDelete = (id) => {

        let removeobj = this.state.requiredFields.find(o=>o.id == id);
        let removeobjIndex = this.state.requiredFields.indexOf(removeobj);

        let removequestion = this.state.task.questions.find(o=>o.id == id);
        let removequestionIndex = this.state.task.questions.indexOf(removequestion);

        if (removeobjIndex != -1){
            this.setState(state => {this.state.requiredFields.splice(removeobjIndex, 1)});
        }
        if (removequestionIndex != -1){
            this.setState(state => {this.state.task.questions.splice(removequestionIndex, 1)});
        }
        this.forceUpdate();
    };


    QuestionFileUpdateRequest = (formData) => {
        return axios.post(config.attachment, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res)=>{
            console.log("upload file res");
            console.log(res);
            this.setState({ tempID: res.data.id });
            return res.data.id;
        })
            .catch(err=>{ console.log(err.response); });
    };

    handleQuestionUpdate = (e, id, questionType) => {
        let updateObj = this.state.task.questions.find(o=>o.id == id);
        let updatequestionIndex = this.state.task.questions.indexOf(updateObj);

        if(e.target.files != null){
            let requiredField = this.state.requiredFields.find(o=>o.id == id);
            let requiredFieldIndex = this.state.requiredFields.indexOf(requiredField);
            console.log(this.state.requiredFields);
            requiredField.attachment_list.push(e.target.files[0]);
            this.setState(state => {this.state.requiredFields[requiredFieldIndex] = requiredField});
        }


        let name = e.target.name;
        let value = e.target.value;

        if (name == "attachment_id"){
            let attachment = e.target.files[0];

            var formData = new FormData();
            var uploads = attachment;
            console.log(uploads);
            formData.append("file", uploads);
            console.log ("formdata");
            console.log(formData);

            this.QuestionFileUpdateRequest(formData).then(data => {
                updateObj[name] = this.state.tempID;
                console.log("updateobj");
                console.log(updateObj);
            });

        }else{
            updateObj[name] = value;
        }

        // console.log (questionType);
        updateObj.question_type = questionType;

        this.setState(state => {this.state.task.questions[updatequestionIndex] = updateObj},()=>{console.log(this.state.task)});
    };

    render() {
        let requiredField = {
            id: 0,
            title: "",
            required: false,
            attachment: false,
            type: "text"
        };
        const suggestions = this.props.users ? this.props.users.map(user=>({
            value: user.email,
            label: user.email
        })) : undefined;
        // console.log("in dialog render")
        // console.log(this.props.users)
        return (
            <Dialog
                open={this.state.open}
                //onClose={this.handleClose}
                scroll={this.state.scroll}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id="scroll-dialog-title">{"Create Task"}</DialogTitle>
                <DialogContent style={{ width: "55vh", height: "100vh" }}>
                    <DialogContentText>
                            Task assignee (Email address)
                    </DialogContentText>
                    {/* <TextField
                        autoFocus

                        id="name"
                        type="email"
                        fullWidth
                        name="task_Assignee"
                        onChange = {this.handleTextfieldChange}
                    /> */}
                    <SearchableDropDown 
                        options= {suggestions}
                        changeHandler={this.handleChange("task_Assignee")}
                        placeholder={"Select a user"}
                    />                  
                    <DialogContentText>
                            Task description
                    </DialogContentText>
                    <TextField
                        id="name"
                        type="text"
                        fullWidth
                        helperText="Some overall description regarding these tasks.."
                        name="description"
                        required={true}
                        onChange = {this.handleTextfieldChange}
                    />
                    <DialogContentText>
                                Due date
                    </DialogContentText>
                    
                    <DatePicker
                        selected={this.state.task.due_date}
                        onChange={this.handleDueDateChange}
                    />

                    <div style={{ height: "1vh" }}></div>
                    <Divider />
                    <DialogContentText>
                        Please specify the required fields for the task:
                    </DialogContentText>
                    {this.state.requiredFields.map((requiredField) => {
                        //console.log(requiredField);
                        return (
                            <div key = {requiredField.id}>
                                <p>
                                    {this.state.requiredFields.indexOf(requiredField) + 1}.
                                    <IconButton aria-label="Delete" disabled>
                                        {requiredField.type == "Text" ? <Edit /> : <AttachFile />}
                                    </IconButton>
                                    <TextField
                                        id="title"
                                        type="email"
                                        style={{ width: "20vw" }}
                                        placeholder={"Description"}
                                        name = {"question_text"}
                                        required="required"
                                        onChange = {(e) => {this.handleQuestionUpdate(e, requiredField.id, requiredField.type);}}
                                    />

                                    <IconButton aria-label="Delete" onClick={()=>{this.handleQuestionDelete(requiredField.id);}}>
                                        <DeleteIcon />
                                    </IconButton>
                                </p>
                                <p style={{marginLeft: "2vw"}}>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-label="Gender"
                                            name="gender1"
                                            value={requiredField.textType}
                                            onChange={(e) => {this.handleRadioGroupChange(e, requiredField.id)}}
                                            row
                                            required="required"
                                            style={requiredField.type == "Text" ? { display: 'inline-flex' } : { display: 'none' }}
                                        >
                                            <FormControlLabel value="free text" control={<Radio />} label="Free text" />
                                            <FormControlLabel value="numbers" control={<Radio />} label="Numbers" />
                                            <FormControlLabel value="date" control={<Radio />} label="Date" />
                                            <FormControlLabel value="boolean" control={<Radio />} label="Boolean" />
                                        </RadioGroup>
                                    </FormControl>
                                </p>
                                <p>
                                    <input
                                        hidden
                                        id={"attach-questoin-file" + requiredField.id}
                                        multiple
                                        required="required"
                                        type="file"
                                        name = {"attachment_id"}
                                        onChange = {(e) => {this.handleQuestionUpdate( e, requiredField.id, requiredField.type)}}
                                    />
                                    <label htmlFor={"attach-questoin-file" + requiredField.id}>
                                        <Button 
                                        variant="contained" 
                                        size="small" 
                                        component="span" 
                                        style={requiredField.type == "Text" ? { display: 'none' } : { display: 'inline-flex' }}>
                                            <AttachFile />
                                            Attach File
                                        </Button>
                                        <p>
                                            {requiredField.attachment_list[0] == null ? null : 
                                                text_truncate(requiredField.attachment_list[0].name,20)}
                                        </p>
                                    </label>
                                </p>
                            </div>
                        );
                    })}
                    <Button variant="contained" style={{ width: "50%" }} onClick={() => {
                        this.state.index++;
                        requiredField.id = this.state.index;
                        requiredField.type = "Text";
                        requiredField.attachment_list = [];
                        this.state.requiredFields.push(requiredField);
                        this.setState({ requiredFields: this.state.requiredFields });
                        this.handleQuestionAdd(requiredField.id);
                        // console.log(this.state.requiredFields);

                    }}>
                        Request for Information
                    </Button>
                    <Button variant="contained" style={{ width: "50%" }} onClick={() => {
                        this.state.index++;
                        requiredField.id = this.state.index;
                        requiredField.type = "Attachment";
                        requiredField.attachment_list = [];
                        this.state.requiredFields.push(requiredField);
                        this.setState({ requiredFields: this.state.requiredFields });
                        this.handleQuestionAdd(requiredField.id);
                        // console.log(this.state.requiredFields);
                    }}>
                        Request for Attachment
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button color="primary">
                        Save
                    </Button>
                    <Button onClick={this.handleSubmit}>
                        Create
                    </Button>
                    <Button onClick={this.handleClose} color="secondary">
                        Discard
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(TaskDialog)


// WEBPACK FOOTER //
// ./src/components/Routines/TaskDialog.js